<template>
  <ui-menu
    v-if="isPaymentIssue"
    v-model="value"
    class="navbar-payment"
    :content-class="{
      'navbar-payment__menu': true,
      [contentClass]: !!contentClass,
    }"
    :close-on-content-click="false"
    :location="location"
    :offset="offset"
  >
    <template #activator="{ props: menuProps }">
      <slot name="activator" v-bind="{ props: menuProps }" :value="value">
        <button
          type="button"
          v-bind="menuProps"
          class="navbar__action-button hidden-md-and-down"
        >
          <ui-icon
            class="mr-4 mt-2 navbar-payment__icon navbar-payment__icon--warning"
            icon="fas fa-exclamation-circle"
          />
          {{ t('Payment') }}
        </button>
      </slot>
    </template>

    <template #menu>
      <div class="navbar-payment__payment-popover">
        <div
          :class="{
            'navbar-payment__payment-popover-header': true,
            'navbar-payment__payment-popover-header--warning':
              cardStatus === 'card-expiring',
          }"
        >
          <template v-if="cardStatus === 'card-expired'">{{
            t('Payment method has expired.')
          }}</template>
          <template v-if="cardStatus === 'card-expiring'">{{
            t('Payment method is expiring.')
          }}</template>
        </div>

        <div class="mb-8" style="line-height: 1.54; font-size: 13px">
          <template v-if="cardStatus === 'card-expired'">
            {{
              t(
                'Your payment method was expired on {0}. Please update it with actual info.',
                [cardExpiryDate],
              )
            }}
          </template>
          <template v-if="cardStatus === 'card-expiring'">
            {{
              t(
                'Your payment method will be expired on {0}. Please update it with actual info.',
                [cardExpiryDate],
              )
            }}
          </template>
        </div>

        <div class="footer-wrapper">
          <ui-button
            class="navbar-payment__footer-button"
            :text="t('Update Payment Info')"
            icon="fas fa-sync-alt"
            @click="handlePaymentClick"
          />
        </div>
      </div>
    </template>
  </ui-menu>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n, usePaymentStatus } from '@/composables';

defineProps<{
  contentClass?: string;
  location?: string;
  offset?: [number, number];
}>();

const emit = defineEmits<{
  (event: 'action', payload: Event): void;
}>();

const router = useRouter();
const { t } = useI18n();
const { cardStatus, isPaymentIssue, cardExpiryDate } = usePaymentStatus();

const value = ref(false);

const handlePaymentClick = (event: Event) => {
  emit('action', event);
  router.push('/app/profile/subscription');
};
</script>

<style lang="scss" scoped>
.footer-wrapper {
  margin-right: -4px;
  margin-left: -4px;
}
</style>

<style lang="scss">
.navbar-payment__payment-popover {
  max-width: 280px;
  min-width: 170px;
  padding: 16px;
}

.navbar-payment__payment-popover-header {
  color: var(--color-red);
  font-size: 18px;
  line-height: 1;
  font-weight: bold;
  margin-bottom: 6px;

  &--warning {
    color: var(--color-tangerine) !important;
  }
}

.navbar-payment__icon {
  color: var(--color-red) !important;

  &:hover {
    color: var(--color-red) !important;
  }
}
</style>
